

(function () {

	/*================ Utils ================*/

	/*================ Vendo ================*/
	class Calendar {
	
		constructor(selector, events, months, days, message) {
			this.el = selector || document.querySelector(selector);
	
			if(!this.el || !months) return;
	
			moment.defaultFormat = 'D MMMM YYYY';
			moment.updateLocale('en', {
				months : months.split('_'),
				weekdaysShort : days.split('_')
			});
	
			this.today = moment();
			this.message = message;
			this.events = events;
			// console.log('events:', events)
			this.current = moment().date(1);
	
			this.defineEvents();
			this.draw();
	
			const current = this.el.querySelector('.today');
			if (current) {
				// current.querySelector('.day-events').classList.add('green');
				window.setTimeout(() => {
					this.openDay(current);
				}, 500);
			}
		}
	
		defineEvents() {
			this.events.forEach((ev) => {
				let start = moment(ev.date, 'D MMMM YYYY').isValid()? moment(ev.date, 'D MMMM YYYY') : moment(ev.date, '-D MMMM YYYY').isValid()? moment(ev.date, '-D MMMM YYYY') : moment(ev.date, 'D-D MMMM YYYY');
				const end = moment(ev.date, '-D MMMM YYYY');
				
				ev.dates = [];
				if (!start.isValid()) return;
				
				if (end.isValid()) {
					while (start.isBefore(end) || start.isSame(end)) {
						ev.dates.push(moment(start));
						start = start.add(1, 'd');						
					}
				} else {
					ev.dates.push(moment(start));
				}	
				
				// this.extractDates(ev.eventName);
			});
		}
	
		// extractDates(title) {		
		// 	const rx = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
		// 	const result = title.match(rx);
	
		// 	console.log(result, title);
		// 	return result; 
		// }
	
		todaysEvents(day) {
			return this.events.reduce((memo, ev) => {
				if (ev.dates) {
					ev.dates.forEach(date => {
						if (date.isSame(day, 'day')) {
							memo.push(ev);
						}
					});
				}
				
				return memo;
			}, []);
		}
	
		draw() {
			//Create Header
			this.drawHeader();
	
			//Draw Month
			this.drawMonth();
	
			// this.drawLegend();
		}
	
		drawHeader() {
			if (!this.header) {
				//Create the header elements
				this.header = this.createElement('div', 'header');
				this.header.className = 'header';
	
				this.title = this.createElement('div');
				this.title.className = 'simple-calendar--title';
	
				var right = this.createElement('div', 'right');
				right.addEventListener('click', () => {
					this.nextMonth();
				});
	
				var left = this.createElement('div', 'left');
				left.addEventListener('click', () => {
					this.prevMonth();
				});
	
				//Append the Elements
				this.header.appendChild(this.title);
				this.header.appendChild(right);
				this.header.appendChild(left);
				this.el.appendChild(this.header);
			}
	
			this.title.innerHTML = this.current.format('MMMM YYYY');
		}
	
		drawMonth() {
			if (this.month) {
				this.oldMonth = this.month;
				this.oldMonth.className = 'month out ' + (this.next ? 'next' : 'prev');
				this.oldMonth.addEventListener('webkitAnimationEnd', () => {
					this.oldMonth.parentNode.removeChild(this.oldMonth);
					this.month = this.createElement('div', 'month');
					this.backFill();
					this.currentMonth();
					this.fowardFill();
					this.el.appendChild(this.month);
					window.setTimeout(() => {
						this.month.className = 'month in ' + (this.next ? 'next' : 'prev');
					}, 16);
				});
			} else {
				this.month = this.createElement('div', 'month');
				this.el.appendChild(this.month);
				this.backFill();
				this.currentMonth();
				this.fowardFill();
				this.month.className = 'month new';
			}
		}
	
		backFill() {
			var clone = this.current.clone();
			var dayOfWeek = clone.day();
	
			if (!dayOfWeek) {
				return;
			}
	
			clone.subtract(dayOfWeek + 1, 'days');
	
			for (var i = dayOfWeek; i > 0; i--) {
				this.drawDay(clone.add(1, 'days'));
			}
		}
	
		fowardFill() {
			var clone = this.current.clone().add(1, 'months').subtract(1, 'days');
			var dayOfWeek = clone.day();
	
			if (dayOfWeek === 6) {
				return;
			}
	
			for (var i = dayOfWeek; i < 6; i++) {
				this.drawDay(clone.add(1, 'days'));
			}
		}
	
		currentMonth() {
			var clone = this.current.clone();
	
			while (clone.month() === this.current.month()) {
				this.drawDay(clone);
				clone.add(1, 'days');
			}
		}
	
		getWeek(day) {
			if (!this.week || day.day() === 0) {
				this.week = this.createElement('div', 'week');
				this.month.appendChild(this.week);
			}
		}
	
		drawDay(day) {
			this.getWeek(day);
	
			const outer = this.createElement('div', this.getDayClass(day));
			// const name = this.createElement('div', 'day-name', day.format('ddd'));
			const number = this.createElement('div', 'day-number', day.format('DD'));
			const events = this.createElement('div', 'day-events');
	
			outer.addEventListener('click', (evt) => {
				this.openDay(evt.currentTarget);
			});
	
			this.drawEvents(day, events);
	
			// outer.appendChild(name);
			outer.appendChild(number);
			outer.appendChild(events);
	
			this.week.appendChild(outer);
		}
	
		drawEvents(day, element) {
			if (day.month() === this.current.month()) {			
				if (this.todaysEvents(day).length) {
					element.classList.add('yellow');
					// console.log(this.todaysEvents(day))
				}
			}
		}
	
		getDayClass(day) {
			const classes = ['day'];
			if (day.month() !== this.current.month()) {
				classes.push('other');
			} else if (this.today.isSame(day, 'day')) {
				classes.push('today');
			}
			return classes.join(' ');
		}
	
		openDay(el) {
			let details, arrow;
			const dayNumber = el.querySelectorAll('.day-number')[0].innerText || el.querySelectorAll('.day-number')[0].textContent;
			const day = this.current.clone().date(dayNumber);
			
			const currentOpened = this.el.querySelector('.details');
	
			//Check to see if there is an open detais box on the current row
			if (currentOpened && currentOpened.parentNode === el.parentNode) {
				details = currentOpened;
				arrow = this.el.querySelector('.arrow');
			} else {
				//Close the open events on differnt week row
				//currentOpened && currentOpened.parentNode.removeChild(currentOpened);
				if (currentOpened) {
					currentOpened.addEventListener('webkitAnimationEnd', () => {
						currentOpened.parentNode.removeChild(currentOpened);
					});
					currentOpened.addEventListener('oanimationend', () => {
						currentOpened.parentNode.removeChild(currentOpened);
					});
					currentOpened.addEventListener('msAnimationEnd', () => {
						currentOpened.parentNode.removeChild(currentOpened);
					});
					currentOpened.addEventListener('animationend', () => {
						currentOpened.parentNode.removeChild(currentOpened);
					});
					currentOpened.className = 'details out';
				}
	
				//Create the Details Container
				details = this.createElement('div', 'details in');
	
				//Create the arrow
				arrow = this.createElement('div', 'arrow');
	
				//Create the event wrapper
	
				details.appendChild(arrow);
				el.parentNode.appendChild(details);
			}
	
			// const todaysEvents = this.events.reduce((memo, ev) => {
			// 	if (ev.date.isSame(day, 'day')) {
			// 		memo.push(ev);
			// 	}
			// 	return memo;
			// }, []);
	
			this.renderEvents(this.todaysEvents(day), details);
	
			arrow.style.left = el.offsetLeft + (el.clientWidth / 2 - 2) + 'px';
		}
	
		renderEvents(events, ele) {
			//Remove any events in the current details element
			const currentWrapper = ele.querySelector('.events');
			const wrapper = this.createElement('div', 'events in' + (currentWrapper ? ' new' : ''));
	
			events.forEach((ev) => {
				const div = this.createElement('div', 'event');
				const square = this.createElement('div', 'event-category yellow');
				// const span = this.createElement('a', '', ev.eventName);
	
				div.innerHTML = ev.eventName;
				div.appendChild(square);
				wrapper.appendChild(div);
			});
	
			if (!events.length) {
				const div = this.createElement('div', 'event empty');
				const span = this.createElement('span', '', this.message);
	
				div.appendChild(span);
				wrapper.appendChild(div);
			}
	
			if (currentWrapper) {
				currentWrapper.className = 'events out';
				currentWrapper.addEventListener('webkitAnimationEnd', () => {
					currentWrapper.parentNode.removeChild(currentWrapper);
					ele.appendChild(wrapper);
				});
				currentWrapper.addEventListener('oanimationend', () => {
					currentWrapper.parentNode.removeChild(currentWrapper);
					ele.appendChild(wrapper);
				});
				currentWrapper.addEventListener('msAnimationEnd', () => {
					currentWrapper.parentNode.removeChild(currentWrapper);
					ele.appendChild(wrapper);
				});
				currentWrapper.addEventListener('animationend', () => {
					currentWrapper.parentNode.removeChild(currentWrapper);
					ele.appendChild(wrapper);
				});
			} else {
				ele.appendChild(wrapper);
			}
		}
	
		// drawLegend() {
		// 	var legend = this.createElement('div', 'legend');
		// 	var calendars = this.events.map((e) => {
		// 		return e.calendar + '|' + e.color;
		// 	}).reduce((memo, e) => {
		// 		if (memo.indexOf(e) === -1) {
		// 			memo.push(e);
		// 		}
		// 		return memo;
		// 	}, []).forEach((e) => {
		// 		var parts = e.split('|');
		// 		var entry = this.createElement('span', 'entry ' + parts[1], parts[0]);
		// 		legend.appendChild(entry);
		// 	});
		// 	this.el.appendChild(legend);
		// }
	
		nextMonth() {
			this.current.add(1, 'months');
			this.next = true;
			this.draw();
		}
	
		prevMonth() {
			this.current.subtract(1, 'months');
			this.next = false;
			this.draw();
		}
	
		createElement(tagName, className, innerText) {
			const ele = document.createElement(tagName);
			if (className) {
				ele.className = className;
			}
			if (innerText) {
				ele.innderText = ele.textContent = innerText;
			}
			return ele;
		}
	};
  
  window.addEventListener('DOMContentLoaded', () => {
    
		const calendars = document.querySelectorAll('[data-calendar]');
		if(calendars.length) {
			window.calendar = window.calendar || {};
			const data = window.calendar.data || [];
			const strings = window.calendar.strings || {};

			calendars.forEach((calendar) => {
				new Calendar(
					calendar, 
					data, 
					strings.months, 
					strings.days, 
					strings.message
				);
			});
		}

  });
  
}());
  